import { Partial } from '@40seas/entities/common';
import { CreditReviewNotes } from './credit-review-notes.entity';

export class UpdateCreditReviewNotesDto extends Partial(CreditReviewNotes) {}
